import React from 'react';
import { motion } from 'framer-motion';
import { FiGrid, FiUsers, FiBarChart2, FiSettings, FiActivity, FiPlayCircle } from 'react-icons/fi';
import SafeIcon from './SafeIcon';

const Sidebar = ({ activeView, setActiveView }) => {
  const navItems = [
    { id: 'dashboard', icon: FiGrid, label: 'Radar Home' },
    { id: 'pipeline', icon: FiUsers, label: 'Talent Pipeline' },
    { id: 'analytics', icon: FiBarChart2, label: 'Hiring Insights' },
    { id: 'demo', icon: FiPlayCircle, label: 'Product Demo' },
    { id: 'settings', icon: FiSettings, label: 'System Config' },
  ];

  return (
    <aside className="w-20 lg:w-64 bg-slate-950 border-r border-slate-800 flex flex-col h-screen transition-all duration-300 z-30">
      <div className="h-16 flex items-center justify-center lg:justify-start lg:px-6 border-b border-slate-800">
        <SafeIcon icon={FiActivity} className="text-blue-500 text-2xl lg:mr-3" />
        <span className="hidden lg:block text-slate-100 font-bold tracking-widest uppercase text-sm">
          RecruitRay<span className="text-blue-500">_</span>
        </span>
      </div>

      <nav className="flex-1 py-6 flex flex-col gap-2 px-3 overflow-y-auto custom-scrollbar">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => setActiveView(item.id)}
            className={`flex items-center p-3 rounded-lg transition-all duration-200 group relative
              ${activeView === item.id 
                ? 'bg-blue-500/10 text-blue-400 border border-blue-500/20 shadow-[0_0_15px_rgba(59,130,246,0.1)]' 
                : 'text-slate-400 hover:bg-slate-900 hover:text-slate-200'}`}
          >
            {activeView === item.id && (
              <motion.div
                layoutId="activeNav"
                className="absolute left-0 w-1 h-3/4 bg-blue-500 rounded-r-full"
                initial={false}
                transition={{ type: "spring", stiffness: 300, damping: 30 }}
              />
            )}
            <SafeIcon icon={item.icon} className="text-xl lg:mr-3 mx-auto lg:mx-0" />
            <span className="hidden lg:block text-sm font-medium">{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="p-4 border-t border-slate-800 text-center">
        <p className="text-[10px] text-slate-600 uppercase tracking-wider hidden lg:block">
          Made by LingLink AI and DigLab AI
        </p>
        <p className="text-[10px] text-slate-600 uppercase tracking-wider lg:hidden">
          LL/DL
        </p>
      </div>
    </aside>
  );
};

export default Sidebar;